import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("novatus_user");
    return stored ? JSON.parse(stored) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("novatus_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/users/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("novatus_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("novatus_token");
        localStorage.removeItem("novatus_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("novatus_token", token);
    localStorage.setItem("novatus_user", JSON.stringify(userData));
    setUser(userData);
    window.dispatchEvent(new Event("novatus:auth-changed"));
  };

  const logout = () => {
    localStorage.removeItem("novatus_token");
    localStorage.removeItem("novatus_user");
    localStorage.removeItem("novatus_acting_tenant_id");
    setUser(null);
    window.dispatchEvent(new Event("novatus:auth-changed"));
  };

  const refresh = async () => {
    try {
      const r = await api.get("/users/me");
      setUser(r.data);
      localStorage.setItem("novatus_user", JSON.stringify(r.data));
      return r.data;
    } catch (e) {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
